/* sln-wishlist.js - wishlist in localStorage (try/catch), hearts, header link. Per-browser only. */
(function () {
  if (window.slnWl) return;
  var cfg = window.slnCfg || {};
  var T = cfg.t || {};
  var KEY = 'sln_wishlist';
  var mem = [];
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 21s-8-5.2-9.6-10C1.3 7.6 3.4 4.5 6.6 4.5c2.1 0 3.7 1.2 5.4 3.2 1.7-2 3.3-3.2 5.4-3.2 3.2 0 5.3 3.1 4.2 6.5C20 15.8 12 21 12 21z"/></svg>';

  function load() {
    try {
      var raw = localStorage.getItem(KEY);
      var l = raw ? JSON.parse(raw) : [];
      if (Array.isArray(l)) mem = l.filter(function (x) { return typeof x === 'string' && x; });
    } catch (e) {}
    return mem.slice();
  }
  function notify() { document.dispatchEvent(new CustomEvent('sln:wishlist')); }
  function save(l) {
    mem = l.slice();
    try { localStorage.setItem(KEY, JSON.stringify(mem)); } catch (e) {}
    notify();
  }
  function has(h) { return load().indexOf(h) !== -1; }
  function add(h) { var l = load(); if (l.indexOf(h) === -1) { l.push(h); save(l); } }
  function remove(h) { save(load().filter(function (x) { return x !== h; })); }
  function toggle(h) { if (has(h)) remove(h); else add(h); }

  window.addEventListener('storage', function (e) {
    if (e.key === KEY || e.key === null) { load(); notify(); }
  });

  function handleFromHref(href) {
    var m = /\/products\/([^\/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  function makeHeart(handle, inline) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sln-heart' + (inline ? ' sln-heart--inline' : '');
    b.setAttribute('data-sln-heart', handle);
    b.setAttribute('aria-pressed', 'false');
    b.innerHTML = HEART + (inline ? '<span class="sln-heart__text"></span>' : '');
    if (!inline) b.setAttribute('aria-label', T.wishAdd);
    return b;
  }

  function paintAll() {
    var l = load();
    document.querySelectorAll('[data-sln-heart]').forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-sln-heart')) !== -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var txt = b.querySelector('.sln-heart__text');
      if (txt) txt.textContent = on ? T.wishSaved : T.wishSave;
      else b.setAttribute('aria-label', on ? T.wishRemove : T.wishAdd);
    });
    var c = document.querySelector('.sln-wl-count');
    if (c) { c.textContent = String(l.length); c.hidden = !l.length; }
    var link = document.querySelector('.sln-wl-link');
    if (link) link.setAttribute('aria-label', T.wishPage + ' (' + l.length + ')');
  }

  function decorate() {
    document.querySelectorAll('.card-wrapper:not([data-sln-wl])').forEach(function (w) {
      w.setAttribute('data-sln-wl', '1');
      var a = w.querySelector('a[href*="/products/"]');
      var h = a && handleFromHref(a.getAttribute('href'));
      if (h) w.appendChild(makeHeart(h, false));
    });
    if (cfg.productHandle && !document.querySelector('.sln-heart--inline')) {
      var title = document.querySelector('.product__title');
      if (title) title.insertAdjacentElement('afterend', makeHeart(cfg.productHandle, true));
    }
    var cart = document.getElementById('cart-icon-bubble');
    if (cart && cart.parentNode && !document.querySelector('.sln-wl-link')) {
      var a2 = document.createElement('a');
      a2.className = 'header__icon link focus-inset sln-wl-link';
      a2.href = cfg.pageUrl;
      a2.innerHTML = HEART + '<span class="sln-wl-count" aria-hidden="true" hidden></span>';
      cart.parentNode.insertBefore(a2, cart);
    }
    paintAll();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sln-heart]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(b.getAttribute('data-sln-heart'));
  }, true);
  document.addEventListener('sln:wishlist', paintAll);

  window.slnWl = {
    all: load, has: has, add: add, remove: remove, toggle: toggle,
    set: function (l) { save(l); },
    clear: function () { save([]); },
    onChange: function (fn) { document.addEventListener('sln:wishlist', fn); }
  };

  function start() {
    decorate();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; decorate(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();